<template>
    <section class="Section WhiteDust">
			<div class="Container">
				<div class="BoxWide">
					<div class="Bookmark"><span>Quick links</span></div>
					<div class="QuickLinksHolder">
						<div class="QuickLink">
							<router-link :to="{name : 'Interventi'}">
								<div class="QuickLinkImage"><img src="/App_Skins/Sito/images/IconaInterventi.png" srcset="/App_Skins/Sito/images/IconaInterventiRetina.png 2x" alt="" /></div>
								<div class="QuickLinkText">Interventi<span>{{this.numInterventiInCarico}}</span></div><!-- Il valore dello span rappresenta il numero di interventi presi in carico -->
							</router-link>
						</div>
						<div class="QuickLink">
							<router-link :to="{name: 'Scadenzario'}">
								<div class="QuickLinkImage"><img src="/App_Skins/Sito/images/IconaScadenzario.png" srcset="/App_Skins/Sito/images/IconaScadenzarioRetina.png 2x" alt="" /></div>
								<div class="QuickLinkText">Scadenzario</div>
							</router-link>
						</div>
						<div class="QuickLink">
							<router-link :to="{name : 'Entita'}">
								<div class="QuickLinkImage"><img src="/App_Skins/Sito/images/IconaEntita.png" srcset="/App_Skins/Sito/images/IconaEntitaRetina.png 2x" alt="" /></div>
								<div class="QuickLinkText">Entità</div>
							</router-link>
						</div>
						<div class="QuickLink">
							<router-link :to="{name : 'Contratti'}">
								<div class="QuickLinkImage"><img src="/App_Skins/Sito/images/IconaContratti.png" srcset="/App_Skins/Sito/images/IconaContrattiRetina.png 2x" alt="" /></div>
								<div class="QuickLinkText">Contratto</div>
							</router-link>
						</div>
						<!-- <div class="QuickLink AddNew">
							<a href="/"><i>Aggiungi Nuovo</i></a>
						</div> -->
					</div>
				</div>
			</div>
		</section>
</template>

<script>

import {apiMixin} from "/mixin.js";
import Intervento from "@/models/intervento.model.js"

export default {
    name: "QuickLinks",
	data(){
		return {
			numInterventiInCarico: 0
		}
	},
	mixins: [apiMixin],
	mounted: function(){

        this.doApiCall("get", "interventi/GetInterventiInCarico", this.$store.getters.getUtente.Token).then(

            (data) => {                
                if(data){
                    let listaInterventi = data.map(o => {
                        return Object.assign(new Intervento(), o)
                    });
                    this.numInterventiInCarico = listaInterventi.length;
                }
            }
        );
    }
}
</script>